import { useEffect, useState } from 'react';
import { debounce } from 'utils/common';
import { useSelector } from 'react-redux';

export default function useStockHistoryFilter(pageSettings, setPageSettings) {
    const {
        userData, userDataLoading,
        uniformSizes, uniformSizesLoading
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false);
    const [filters, setFilters] = useState([
        {
            key: "search",
            label: "Search term",
            value: ""
        },
        {
            key: "size",
            label: "Size",
            value: ""
        },
        {
            key: "created_by",
            label: "Created By",
            value: ""
        },
        {
            key: "stock_date",
            label: "Stock Date",
            value: ""
        }
    ]);

    useEffect(() => {
        if (!userDataLoading && !uniformSizesLoading) {
            let _filters = [
                {
                    key: "search",
                    label: "Search term",
                    value: ""
                },
                {
                    key: "size",
                    label: "Size",
                    value: ""
                },
                {
                    key: "created_by",
                    label: "Created By",
                    value: ""
                },
                {
                    key: "stock_date",
                    label: "Stock Date",
                    value: ""
                }
            ];
            setFilters(_filters);
        }
    }, [userData, uniformSizes, userDataLoading, uniformSizesLoading]);

    const handleInputChange = debounce((data, key, make_call = false) => {
        let _filters = [...filters];
        let selectedFilter = _filters.find(item => item.key === key);
        selectedFilter['label'] = key;
        selectedFilter['value'] = data;
        setFilters(_filters);

        if (make_call) {
            setPageSettings({
                ...pageSettings,
                page: 1,
                filters: _filters
            });
        }
    }, 1000);

    const handleFilterChange = (data, key, make_call = false) => {
        let _filters = [...filters];
        let selectedFilter = _filters.find(item => item.key === key);

        selectedFilter['label'] = data?.label || "";
        selectedFilter['value'] = data?.value || "";
        setFilters(_filters);

        if (make_call) {
            setPageSettings({
                ...pageSettings,
                page: 1,
                filters: _filters
            });
        }
    };

    const handleDateChange = (data, key, make_call = false) => {
        let _filters = [...filters];
        let selectedFilter = _filters.find(item => item.key === key);

        selectedFilter['label'] = key;
        selectedFilter['value'] = data || "";
        setFilters(_filters);

        if (make_call) {
            setPageSettings({
                ...pageSettings,
                page: 1,
                filters: _filters
            });
        }
    };

    return {
        handleFilterChange,
        filters,
        filterLoading,
        setFilterLoading,
        handleInputChange,
        handleDateChange
    };
}

